import React, { useState } from "react";
import { UI_Modal_Clone } from "../../../UiComponents";
import { cloneProject } from "../../../Redux/actions/projectActions";
import { useDispatch } from "react-redux";
import Styles from "./CloneProjectModal.module.css";
import { Button, Loader, Loader2 } from "../../../Components/";

export default function CloneProjectModal({
  projectCloneModalOpen,
  setProjectCloneModalOpen,
  projectId,
  setCloneMsg,
  setSuccessModal,
  setLoading,
  closeModal,
  projectType
}) {
  const [title, setTitle] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const dispatch = useDispatch();
  const handleCloneProject = async () => {
    if (title === "") {
      setErrorMsg("Please Add Tiltle");
      return;
    }
    if (!projectId) {
      setErrorMsg("Project ID Does Not Exist");
      return;
    }
    setLoading(true);
    let isCard = projectType === "scroll" ? false : true;
    const res = await dispatch(cloneProject(projectId, title, isCard));
    if (res?.status === 200 && res?.data?.success) {
      setProjectCloneModalOpen(false);
      setTitle("");
      setErrorMsg("");
      setCloneMsg(res?.data?.message);
      setSuccessModal(true);
      setLoading(false);
    } else {
      setErrorMsg(res?.response?.data?.error);
      setLoading(false);
    }
  };
  const closeModalHandle = () => {
    setProjectCloneModalOpen(false);
    setTitle("");
    setErrorMsg("");
    setCloneMsg("");
  };
  const onChangeHandler = (e) => {
    setTitle(e.target.value);
    setErrorMsg("");
  };
  const handleKeypress = (e) => {
    if (e.key === "Enter" && (e.code === "Enter" || e.code === "NumpadEnter")) {
      handleCloneProject();
    }
  };
  return (
    <UI_Modal_Clone
      isOpen={projectCloneModalOpen}
      closeModal={closeModalHandle}
      title="Duplicate Project"
    >
      {/* {loading ? <Loader2 label={"Duplicating Project..."} /> : null} */}

      <div className={Styles.mainContainer}>
        {/* <div className={Styles.containerTitle}>Title</div> */}
        <div className={Styles.containerInput}>
          <input
            type="text"
            className={Styles.titleInputBox}
            placeholder="Name"
            value={title}
            onChange={(e) => onChangeHandler(e)}
            onKeyDown={handleKeypress}
          />
        </div>
      </div>
      <p className="inValidOtpFP">{errorMsg}</p>
      <div className={Styles.containerButton}>
        <div className="cancel_btn_ui manrope-600 text-base" onClick={closeModalHandle} >Cancel</div>
        <div className="manrope-600 text-base text-white rounded-[10px] bg-[#4b3fcb] px-[22px] py-[4px] border-[1px] border-[#ffffff33] text-lg"
          onClick={handleCloneProject}
          disabled={!title || title === ""}
        >
          Confirm
        </div>
      </div>
    </UI_Modal_Clone>
  );
}
